import { createFileRoute } from '@tanstack/react-router';

import { PackagesPage } from '@/features/packages';

export const Route = createFileRoute(
  '/_authed/dashboard/l/$locationId/catalog/packages'
)({
  component: PackagesPage,
});
